// extracted by mini-css-extract-plugin
export default {"confirmModal":"confirm_confirmModal__in6JX"};